// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Create2dFloodModelOutput } from "./Create2dFloodModelOutput";
import {
  Create2dFloodModelOutputFromJSON,
  Create2dFloodModelOutputFromJSONTyped,
  Create2dFloodModelOutputToJSON,
  Create2dFloodModelOutputToJSONTyped,
} from "./Create2dFloodModelOutput";
import type { Create2dFloodModelInput } from "./Create2dFloodModelInput";
import {
  Create2dFloodModelInputFromJSON,
  Create2dFloodModelInputFromJSONTyped,
  Create2dFloodModelInputToJSON,
  Create2dFloodModelInputToJSONTyped,
} from "./Create2dFloodModelInput";

/**
 *
 * @export
 * @interface Create2dFloodModelSchema
 */
export interface Create2dFloodModelSchema {
  /**
   *
   */
  tag: Create2dFloodModelSchemaTagEnum;
  /**
   *
   */
  inputs: Create2dFloodModelInput;
  /**
   *
   */
  outputs: Create2dFloodModelOutput;
}

/**
 * @export
 */
export const Create2dFloodModelSchemaTagEnum = {
  Create2dFloodModel: "create_2d_flood_model",
} as const;
export type Create2dFloodModelSchemaTagEnum =
  (typeof Create2dFloodModelSchemaTagEnum)[keyof typeof Create2dFloodModelSchemaTagEnum];

/**
 * Check if a given object implements the Create2dFloodModelSchema interface.
 */
export function instanceOfCreate2dFloodModelSchema(
  value: object
): value is Create2dFloodModelSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "create_2d_flood_model") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function Create2dFloodModelSchemaFromJSON(json: any): Create2dFloodModelSchema {
  return Create2dFloodModelSchemaFromJSONTyped(json, false);
}

export function Create2dFloodModelSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Create2dFloodModelSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: Create2dFloodModelInputFromJSON(json["inputs"]),
    outputs: Create2dFloodModelOutputFromJSON(json["outputs"]),
  };
}

export function Create2dFloodModelSchemaToJSON(json: any): Create2dFloodModelSchema {
  return Create2dFloodModelSchemaToJSONTyped(json, false);
}

export function Create2dFloodModelSchemaToJSONTyped(
  value?: Create2dFloodModelSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: Create2dFloodModelInputToJSON(value["inputs"]),
    outputs: Create2dFloodModelOutputToJSON(value["outputs"]),
  };
}
